import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { BiTematica } from '../models/bi-tematica.model';

@Injectable({
  providedIn: 'root',
})
export class BiTematicaService extends BaseService<BiTematica> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/bi-tematica';
  }

}
